/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingCommitmentBase {
    getFixupPrototypeFunction() { return BillingCommitmentBase.fixupPrototype; }

    static newInstance(model: Partial<BillingCommitmentBase>): BillingCommitmentBase {
        let obj = Object.assign(new BillingCommitmentBase(), model);
        BillingCommitmentBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingCommitmentBase>): BillingCommitmentBase {
        if (!model) return null;
        return BillingCommitmentBase.newInstance(<BillingCommitmentBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingCommitmentBase) {
        if (!obj) return;

        models.BillingCommitmentBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingCommitmentBase): boolean {
        Object.setPrototypeOf(obj, BillingCommitmentBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.remaining_commitment_amount === undefined) {
            this.remaining_commitment_amount = 0;
        }
    }

    /**
     * Remaining Billing Commitment Amount
     */
    remaining_commitment_amount: number;

    /**
     * Billing Currency
     */
    currency: models.Currency;

}
